export const a = 'dao';
export const version = "1.0.0";
export { default as Title } from './Title';